import { Component } from "react"
import { COLUMN_CODE, TableManger, TABLES } from "../../managers/TableManger";
import DataGridHolder from "../common/DataGridHolder";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import EmailTypeSelector from "./EmailTypeSelector";
import { DKIcons, DKTooltipWrapper, DKFilterPopup, DKInput, DKButton, DKIcon, DKLabel, Toggle, DKSpinner, removeLoader, showToast, TOAST_TYPE, showLoader, showAlert } from "deskera-ui-library"
import EmailTemplateManager from "./EmailPageManager";
import { EMAIL_COMPOSER_DIMENSIONS } from "../automation/AutomationConstants";
import Utility from "../../utility/Utility";
import EmailEditor from "../email_editor/EmailEditor_Quill";
import { INPUT_VIEW_DIRECTION } from "../SequenceNumberFormat/Other";
import EmailTemplate1 from "./basicEmailTemplates/Template1";
import Table from "../../services/table";
import { decodeBase64Uri, encodeBase64Uri } from "../../managers/common/CommonUtil";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";
export default class EmailTemplateList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refresh: false,
      needCampaignTypeSelector: false,
      templatePopup: false,
      emailEditorPopup: false,
      body: EmailTemplate1.getTemplate(),
      templateName: '',
      refresh: false,
      isEdit: false
    }
  }
  toggleCampaignTypeSelector = (shouldOpen) => {
    this.setState((prevState) => ({
      needCampaignTypeSelector:
        shouldOpen ?? !prevState.needCampaignTypeSelector,
    }));
  };
  componentDidMount() {
    RouteManager.setPresenter(this);
  }

  getGrid() {
    return (
      <div className="column mt-l parent-width mb-s position-relative flex-1 margin-empty-mobile parent-height">
        <DataGridHolder
          tableName={TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE}
          module={MODULE.EMAIL_TEMPLATE}
          allowRowEdit={PermissionUtils.hasAccess(MODULE.EMAIL_TEMPLATE, [ACTION.EDIT])}
          allowColumnEdit={PermissionUtils.hasAccess(MODULE.EMAIL_TEMPLATE, [ACTION.EDIT])}
          allowRowAdd={true}
          allowColumnAdd={true}
          allowColumnDelete={PermissionUtils.hasAccess(MODULE.EMAIL_TEMPLATE, [ACTION.DELETE])}
          allowColumnShift={true}
          allowSearch={true}
          allowFilter={true}
          onEmployeeToAdd={(data) => this.onEmployeeToAdd(data)}
          onRowSelect={(selectedRows) => {
            const selectedRowIds = selectedRows?.map((row) => row.id) || [];
            this.setState({ selectedRows: selectedRowIds, refresh: false });
          }}
          onRowDelete={(data) => { }}
          onRowEdit={(data) => {

            const mailBodyId = TableManger.getColumnId(TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE, COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.HTML_DATA)
            const name = TableManger.getColumnId(TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE, COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.NAME)
            const mailBody = decodeBase64Uri(data.rowData[mailBodyId])
            EmailTemplateManager.setSelectedTemplate(mailBody);
            EmailTemplateManager.setPageData(data.rowData);
            this.setState({
              templatePopup: false,
              emailEditorPopup: true,
              templateName: data.rowData[name],
              body: mailBody,
              isEdit: true
            })
          }}
          refresh={this.state.refresh}
          addButtonConfig={{

            title: "+ New Email Template",
            className: "bg-app text-white ml-m",
            onClick: () => {
              EmailTemplateManager.setSelectedTemplate(null);
              EmailTemplateManager.setPageData(null);
              this.setState({
                templatePopup: true,
                isEdit: false
              })
            },
          }}
          allowDataExport={true}
          contextMenu={true}
          onViewContact={(data) =>
            this.onViewContact(data)
          }
          moduleName={"Candidate"}
          refresh={this.state.refresh}
        />
      </div>
    )
  }
  selectTemplatePopup() {
    return (
      <div className=" transparent-background">
        <div className="p-h-r pt-r pb-m popup-window custom-popup-outer" style={{ padding: 0, minWidth: "25%", width: "100%", overflow: "visible" }} >
          <div className="row justify-content-between p-h-m p-v-s bg-gray2">
            <DKLabel text={"Select Template"} className="fs-l fw-m" />
            <DKButton icon={DKIcons.ic_close} onClick={() => this.setState({ templatePopup: false })} />
          </div>
          <div className=" parent-width p-m custom-popup-body justify-content-between row">
            <div className="row flex-wrap  pb-m align-items-start" style={{ justifyContent: "space-between" }}>
              {this.getAllTemplates()}
            </div>
          </div>
          <div className="row justify-content-center mb-r">

            <DKButton title="Blank Template" className="border-m" onClick={() => {
              this.setState({
                templatePopup: false,
                emailEditorPopup: true,
                templateName: "",
                body: ""
              })
            }} />
          </div>
        </div>
      </div>
    )
  }
  getAllTemplates() {
    const templates = EmailTemplateManager.getEmailTemplates();
    return templates.map((img, index) => {
      return (
        <div
          className="border-m mt-xl cursor-hand"//template-active
          style={{ width: 135 }}
          onClick={() => {
            this.onTemplateSelect(index);
          }}
        >
          <DKTooltipWrapper
            content={EmailTemplateManager.getDefaultEmailTemplateName(index)}
            tooltipClassName="warning-tooltip-prop warning-tooltip-prop "
          >
            <img src={img} alt="" className="parent-width" />
          </DKTooltipWrapper>
        </div>
      );
    });
  }
  onTemplateSelect(index) {
    EmailTemplateManager.setSelectedTemplate(EmailTemplateManager.getDefaultEmailTemplate(index));
    this.setState({
      templatePopup: false,
      emailEditorPopup: true,
      templateName: "",
      body: EmailTemplateManager.getDefaultEmailTemplate(index)
    })
  }
  getEmailEditor() {
    let additionalPlaceholders = [];
    const editorHeight = EMAIL_COMPOSER_DIMENSIONS.editorHeight - (Utility.isEmptyObject(this.props.emailToOptions) ? 0 : EMAIL_COMPOSER_DIMENSIONS.fieldHeight);
    return (
      <div className=" transparent-background">
        <div className="p-h-r pt-r pb-m popup-window " style={{ padding: 0, minWidth: "40%", width: "100%", overflow: "hidden" }} >

          <div className="row justify-content-between p-h-m p-v-s bg-gray2">
            <DKLabel text={"Email Template Designer"} className="fs-l fw-m" />
            <div className="d-flex">
              <DKButton title="Close" className="bg-gray1 border-m" onClick={() => {
                EmailTemplateManager.setSelectedTemplate(null);
                this.setState({ emailEditorPopup: false })
              }} />
              <DKButton title={this.state.isEdit ? "Update" : "Save"} className="bg-app text-white ml-m border-m" onClick={() => {
                this.onSave()
              }} />

            </div>
          </div>
          <DKInput
            title={"Template Name"}
            type={"text"}
            className={"p-m"}
            direction={INPUT_VIEW_DIRECTION.VERTICAL}
            required={true}
            canValidate={this.state.canValidate}
            errorMessage={''}
            value={this.state.templateName}
            validator={(value) => {
              if (Utility.isEmpty(value.trim())) {
                return false;
              } else {
                return true;
              }
            }}
            onChange={(value) => {
              this.setState({
                templateName: value,
                canValidate: true
              })
            }}
          />
          <div className=" parent-width p-m custom-popup-body row">
            <EmailEditor
              editorID="mail-editor-body-design"
              body={this.state.body}
              height={editorHeight}
              tableName={TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE}
              additionalPlaceholders={additionalPlaceholders}
            />
          </div>
        </div>
      </div>
    )
  }
  onSave() {
    if (Utility.isEmpty(this.state.templateName?.trim())) {
      this.setState({
        canValidate: true
      })
      return;
    }
    let dataToSave = {}
    const div_body = document.getElementById("mail-editor-body-design");
    dataToSave["body"] = this.getDataToSave(div_body);
    if (Utility.isEmpty(dataToSave["body"]) || (dataToSave['body'] == '<div><br></div>')) {
      showToast('Template body should not empty', TOAST_TYPE.FAILURE);
      return;
    }
    dataToSave["body"] = encodeBase64Uri(dataToSave["body"]);
    const cells = {
      [TableManger.getColumnId(TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE, COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.NAME)]: this.state.templateName,
      [TableManger.getColumnId(TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE, COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.HTML_DATA)]: dataToSave["body"],
      [TableManger.getColumnId(TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE, COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.STATUS)]: [1],
      [TableManger.getColumnId(TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE, COLUMN_CODE.PEOPLE_BASIC_EMAIL_TEMPLATE.DEFAULT)]: false
    }
    let record = {
      cells: cells
    }
    if (this.state.isEdit) {
      const record = EmailTemplateManager.getPageData();
      showLoader("Updating template...");
      Table.updateRecord(cells, record.id, TableManger.getTableId(TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE)).then(response => {
        showToast("Template updated successfully.", TOAST_TYPE.SUCCESS);
        EmailTemplateManager.setSelectedTemplate(null);
        this.setState({ emailEditorPopup: false, refresh: !this.state.refresh })
        removeLoader()
      }, error => {
        showToast("Unable to update Template", TOAST_TYPE.SUCCESS);
        removeLoader()
      })
    } else {
      showLoader("Adding template...");
      Table.addRecord(record, TableManger.getTableId(TABLES.PEOPLE_BASIC_EMAIL_TEMPLATE))
        .then(response => {
          showToast("Template added successfully.", TOAST_TYPE.SUCCESS);
          EmailTemplateManager.setSelectedTemplate(null);
          removeLoader()
          this.setState({ emailEditorPopup: false, refresh: !this.state.refresh })
        }, error => {
          removeLoader()
          showToast("Unable to save Template", TOAST_TYPE.SUCCESS);
        })
    }
  }
  getDataToSave(editor_container) {
    /* picking contents from inner element for handling quill editor */
    const editor_body = editor_container.querySelector(".ql-editor");
    const html_text = editor_body
      ? this.replacePlaceholders(editor_body)
      : editor_container.innerHTML;

    /* sanitize text for email placeholders */
    return html_text;
  }
  replacePlaceholders(editor_body) {
    const placeholders = editor_body.getElementsByClassName(
      "custom_email_placeholder"
    );
    Array.from(placeholders).forEach((placeholder) => {
      const dataId = placeholder.getAttribute("data-id");
      placeholder.innerHTML = `%${dataId}%`;
    });

    return editor_body.innerHTML;
  }
  render() {
    return (
      <>
        <div className="parent-width row position-relative">
          {this.state.needCampaignTypeSelector && (
            <EmailTypeSelector
              style={{
                top: 40,
                right: 0,
              }}
              onClose={() => this.toggleCampaignTypeSelector(false)}
            />
          )}
        </div>
        {this.getGrid()}
        {this.state.templatePopup && this.selectTemplatePopup()}
        {this.state.emailEditorPopup && this.getEmailEditor()}
      </>
    )
  }
}
